import { isEmpty } from 'lodash'

import { Legend, LegendItem } from '#/components/Legend'
import { getCcomMarkersLegends } from '#/components/Maps/Legend/ccom'
import { Markers } from '#/components/Maps/Markers/types'

type Props = {
  markers?: Partial<Markers>
  onChange: (legend: LegendItem) => any
}

// Por definição, de momento será apenas markers de ccom
export default function MapLegend({ markers, onChange }: Props) {
  if (isEmpty(markers?.ccom)) return null

  return <Legend items={getCcomMarkersLegends()} onChange={onChange} />
}
